<template>
	<div class="box box-board">
		
		<div v-if="current.biome.slug" class="location">
			<div v-show="current.location == 'main'" class="dots">
				<div v-for="i in 6" class="dot" :class="{ done: i < current.level, active: i == current.level }"></div>
			</div>
			<p class="title">{{ location_title }}</p>
		</div>
		
		<div class="board">
			<div class="board-content" ref="board">
				
				<div v-if="current.status != 'lose' && current.status != 'win'" class="rows" :class="{ 'animated': current.status == 'monster-attack' }">
					<div v-for="row in board" :key="row.id" class="row" :style="{ transform: 'translateY(' + (card_height * current.row) + 'px)' }" :class="row_class(row)">
						<board-slot v-for="slot in row.slots" :key="slot.id" :current_slot="slot" :visible="row_visible(row.id)" :fog="row_fog(row.id)" />
					</div>
				</div>
			
				<hero :hero="game.player.hero" ref="hero" />
			</div>
		</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import BoardSlot from '@/components/game/board/board-slot'
import Hero from '@/components/game/hero'

export default {
	name: 'board',
	data: function() {
		return {
			card_height: 0
		}
	},
	computed: Object.assign(mapGetters([ 'lang', 'current', 'game', 'nb_rows_hidden' ]), {
		location_title: function() {
			var temp = this.current.biome[this.lang].name
			if (this.current.location != 'main')
				temp = this.game.current[this.current.location].card[this.lang].name
			return temp
		},
		board: function() {
			return this.current.board
		}
	}),
	methods: {
		row_class: function(row) {
			var temp = []
			if (this.row_visible(row.id)) temp.push('visible')
			if (this.row_fog(row.id)) temp.push('hidden')
			if (row.id == this.current.row + 1) temp.push('on-top')
			return temp
		},
		row_visible: function(row_id) {
			return row_id >= this.current.row && row_id < this.current.row + 3
		},
		row_fog: function(row_id) {
			if (this.row_visible(row_id)) {
				return row_id > this.current.row + (2 - this.nb_rows_hidden)
			}
			return false
		}
	},
	mounted: function() {
		this.$nextTick(function() {
			this.card_height = this.$refs.hero.$el.offsetHeight + 8 + 4
		})
	},
	components: { BoardSlot, Hero }
}
</script>

<style lang="stylus">
@import '../../assets/css/app'

.box.box-board
	padding 0
	height 100%
	.location
		position absolute
		left 0
		right 0
		top -48px
		text-align center
		font-size 2.4rem
		line-height 24px
		opacity 0.5
		.dots
			position absolute
			left 0
			right 0
			top -28px
			height 4px
			dispaly flex
			align-items center
			justify-content center
			.dot
				display inline-block
				margin 0 8px
				width 4px
				height 4px
				background-color darken(dark, 50%)
				&.done, &.active
					background-color light
	.rows-bg
		display none
		position absolute
		left 0
		top 0
		right 0
		bottom 0
	.board
		position absolute
		left 0
		right 0
		bottom 0
		height ((card_height + 8px) * 3 + 8px)
		.board-content
			position absolute
			left 0
			right 0
			bottom 0
			padding-bottom (card_height + 8px)
			.rows
				display flex
				justify-content flex-start
				flex-direction column-reverse
				&.animated
					z-index 10
				.row
					display block
					opacity 0
					transition 0.5s easeOutQuart
					will-change transform, opacity
					z-index 2
					&.visible
						opacity 1
					&.hidden
						// opacity 0.25
						.slot
							.card-wrap
								.card
									.card-front
										display none
									.card-back
										display block
					&.on-top
						z-index 10
						.slot
							z-index 10
							.card-wrap
								z-index 10
								.card
									z-index 10


@keyframes monster_attack
	0%
		transform translateY(0) scale(0.85)
		opacity 1
	50%
		transform translateY(85%) scale(1.2)
		opacity 1
	85%
		transform translateY(85%) scale(1.2)
		opacity 1
	100%
		transform translateY(100%) scale(1)
		opacity 0



</style>
